import axios from "axios";

export async function generateJobDescription({
  jobTitle,
  industry,
  experienceLevel,
  location,
  employmentType,
  skills,
  responsibilities,
  qualifications
}) {
  const response = await axios.post("/ai/job-description", {
    jobTitle,
    industry,
    experienceLevel,
    location,
    employmentType,
    skills,
    responsibilities,
    qualifications
  });

  return response.data;
}

export async function generateCandidateMatch({ applicationId }) {
  const response = await axios.post("/ai/candidate-match", {
    applicationId
  });
  return response.data;
}
